import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t('contact.required');
    if (!values.email.trim()) e.email = t('contact.required');
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) e.email = t('contact.emailInvalid');
    if (!values.message.trim()) e.message = t('contact.required');
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    // Frontend only — clear and redirect to thank-you.
    setValues({ name: '', email: '', message: '' });
    navigate('/thank_you');
  };

  return (
    <form onSubmit={onSubmit} noValidate data-testid="contact-form" style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div className="field">
        <label htmlFor="name">{t('contact.nameLabel')}</label>
        <input id="name" name="name" type="text" placeholder={t('contact.namePlaceholder')} value={values.name} onChange={(e) => setValues({ ...values, name: e.target.value })} data-testid="input-name" />
        {errors.name && <span className="err">{errors.name}</span>}
      </div>
      <div className="field">
        <label htmlFor="email">{t('contact.emailLabel')}</label>
        <input id="email" name="email" type="email" placeholder={t('contact.emailPlaceholder')} value={values.email} onChange={(e) => setValues({ ...values, email: e.target.value })} data-testid="input-email" />
        {errors.email && <span className="err">{errors.email}</span>}
      </div>
      <div className="field">
        <label htmlFor="message">{t('contact.messageLabel')}</label>
        <textarea id="message" name="message" rows={5} placeholder={t('contact.messagePlaceholder')} value={values.message} onChange={(e) => setValues({ ...values, message: e.target.value })} data-testid="input-message" />
        {errors.message && <span className="err">{errors.message}</span>}
      </div>
      <button type="submit" className="btn btn-primary" style={{ alignSelf: 'flex-start' }} data-testid="submit-form">
        {t('contact.submit')} <ArrowRight size={16} />
      </button>
    </form>
  );
}
